export default "__VITE_ASSET__Ba$FGPAa__"